import { HandSize, ModelData, Vector } from './Interfaces';

const multiply = (input: Vector, multiplier: number): Vector => [
  input[0] * multiplier,
  input[1] * multiplier,
  input[2] * multiplier
];

type MultParams = {
  mult: number;
  shift: number;
  vert: number;
};

const sizeToParams = (size: HandSize): MultParams => {
  switch (size) {
    case 'big':
      return { mult: 1.6, shift: 3.2, vert: 0.2 };
    case 'middle':
      return { mult: 1.3, shift: 2.6, vert: 0 };
    case 'small':
      return { mult: 1, shift: 1.95, vert: 0.6 };
    case 'ultraSmall':
      return { mult: 0.8, shift: 1.6, vert: 0.8 };
  }
};

export const getDirectModelData = (size: HandSize): ModelData => {
  const params = sizeToParams(size);
  return {
    rotation: [0, Math.PI * 1.5, 0],
    position: [-params.shift, params.vert, 0],
    scale: multiply([1, 1, 1], params.mult)
  };
};

export const getMirrorModelData = (size: HandSize): ModelData => {
  const params = sizeToParams(size);
  return {
    rotation: [0, Math.PI * 0.5, 0],
    position: [params.shift, params.vert, 0],
    scale: multiply([-1, 1, 1], params.mult)
  };
};
